import type { LinkProps as ChakraLinkProps } from "@chakra-ui/react"
import { Link as ChakraLink } from "@chakra-ui/react"
import NextLink from "next/link"
import React from "react"

type Props = Omit<ChakraLinkProps, "as"> & {
  prefetch?: boolean
}

const Link = React.forwardRef<HTMLAnchorElement, Props>(
  ({ children, ...rest }, ref) => (
    <ChakraLink ref={ref} {...rest} as={NextLink}>
      {children}
    </ChakraLink>
  ),
)

Link.displayName = "Link"

export default Link
